import { AssertionError } from './errors';
import { Logger } from '../lib/Logger';
export function assert(condition, message) {
    if (!condition) {
        const error = AssertionError(message);
        Logger.error(error);
        throw error;
    }
}
//# sourceMappingURL=assert.js.map